<template>
  <main-layout
    class="pro-result-page"
    :page-title="text.planTitle"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="result-card">
        <div class="result-head">
          <img class="result-icon" :src="successIcon" alt="" />
          <div class="result-title">{{ text.paySuccess }}</div>
          <div class="result-desc">{{ text.paySuccessDesc }}</div>
        </div>

        <div class="order-card">
          <div class="order-card-title">{{ goodsTitle }}</div>
          <div class="order-card-body">
            <div class="line">
              <span class="label">订单编号：</span
              ><span class="value">{{ order.orderNo }}</span>
            </div>
            <div class="line">
              <span class="label">订单金额：</span
              ><span class="value value-bold">￥{{ order.price }}</span>
            </div>
            <div class="line">
              <span class="label">生效日期：</span
              ><span class="value">{{ order.effectTime }}</span>
            </div>
            <div class="line">
              <span class="label">下单时间：</span
              ><span class="value">{{ order.createTime }}</span>
            </div>
            <div class="line">
              <span class="label">支付方式：</span
              ><span class="value">{{ order.payType }}</span>
            </div>
            <div class="line">
              <span class="label">到期日期：</span
              ><span class="value">{{ order.expireTime }}</span>
            </div>
          </div>
        </div>

        <!-- 操作按钮：设计稿中位于订单卡下方并水平居中（非卡片内右对齐） -->
        <div class="order-actions">
          <span class="btn-outline" @click="goOrderList">{{
            text.viewOrder
          }}</span>
          <span class="btn-primary" @click="goWorkbench">{{
            text.backToWorkbench
          }}</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { PRO_PLAN_TEXT } from "@/consts/proPlan";
import { windowHref } from "@/utils";

export default {
  name: "ProPlanOrderSuccess",
  components: { MainLayout },
  data() {
    return {
      text: PRO_PLAN_TEXT,
      successIcon: require("@/assets/images/pro-plan/plan/pay-success-icon.png"),
    };
  },
  computed: {
    order() {
      const q = this.$route.query;
      return {
        orderNo: q.orderNo || "",
        createTime: q.createTime || "",
        price: q.price || "",
        payType: q.payType || "",
        effectTime: q.effectTime || "",
        expireTime: q.expireTime || "",
        goodsName: q.goodsName || "",
        months: q.months || "",
      };
    },
    goodsTitle() {
      // 设计稿标题直接为套餐名（如「专业版月卡」），不额外拼接时长
      return this.order.goodsName;
    },
  },
  methods: {
    goOrderList() {
      this.$router.push({
        path: "/proPlan/orderList",
        query: { companyId: this.$route.query.companyId },
      });
    },
    goWorkbench() {
      // 返回老端工作台（本项目为扩展端，老端首页为 /home/home）
      windowHref("/home/home");
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  min-height: 100%;
  padding: 60px 0;
  box-sizing: border-box;
  background: #f7f9fb;
  display: flex;
  justify-content: center;
}
.result-card {
  // 设计稿：订单卡 1000 宽（与订单列表卡片保持一致）
  width: 1000px;
}
.result-head {
  display: flex;
  flex-direction: column;
  align-items: center;
}
// 成功图标（设计稿切图，自带绿色圆 + 浅绿光环 + 对勾）
.result-icon {
  width: 60px;
  height: 60px;
  display: block;
}
.result-title {
  margin-top: 24px;
  font-size: 20px;
  font-weight: 700;
  color: #3f454b;
}
.result-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #62717e;
}
.order-card {
  margin-top: 40px;
  background: #fff;
  border-radius: 15px;
  padding: 20px 16px;
}
.order-card-title {
  font-size: 20px;
  font-weight: 700;
  color: #3f454b;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebebeb;
}
.order-card-body {
  // 设计稿：信息区上 20、内容 60、下 40（含最后一行与卡片底的内边距）
  padding: 20px 0 40px;
  display: flex;
  flex-wrap: wrap;
  .line {
    width: 33.33%;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
    &:nth-last-child(-n + 3) {
      margin-bottom: 0;
    }
    // 设计稿 1921:867：标签 #62717E、值 #333333（原先值继承了标签色，导致偏灰）
    .label {
      color: #62717e;
    }
    .value {
      color: #333;
    }
    // 订单金额加粗（设计稿 ts2 = 85 Bold）
    .value-bold {
      font-weight: 700;
    }
  }
}
// 操作按钮：设计稿位于订单卡下方、水平居中（344 = 162 + 20 + 162）
.order-actions {
  margin-top: 38px;
  display: flex;
  justify-content: center;
  gap: 20px;
  .btn-outline,
  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 162px;
    height: 44px;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 4px 20px 0 rgba(0, 196, 140, 0.2);
  }
  .btn-outline {
    color: #0fa87b;
    background: #fff;
    border: 1px solid #ebeef5;
  }
  .btn-primary {
    color: #fff;
    background: #0fa87b;
  }
}
</style>
